import { render, staticRenderFns } from "./CropRotation.vue?vue&type=template&id=70b6920a&scoped=true"
import script from "./CropRotation.vue?vue&type=script&lang=js"
export * from "./CropRotation.vue?vue&type=script&lang=js"
import style0 from "./CropRotation.vue?vue&type=style&index=0&id=70b6920a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b6920a",
  null
  
)

export default component.exports